module.exports = __webpack_public_path__ + "static/media/yourspace-open-office-desk-on-right.63877035.jpg";